import { Component, OnInit } from '@angular/core';
import { User } from '@models/user';
import { UserService } from '@services/user.service';

@Component({
  selector: 'wsb-sms-history',
  templateUrl: './sms-history.component.html',
  styleUrls: ['./sms-history.component.scss'],
  standalone: false
})
export class SmsHistoryComponent implements OnInit {
  activeId = 1;
  user: User;
  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.getUser();
  }

  private getUser(): void {
    this.userService.getAuthenticationState().subscribe(loggedUser => {
      this.user = loggedUser;
    });
  }
}
